import React, {
    useEffect,
    useState
} from "react";

import axios from "axios";

import "./JourneyProgressCard.css";

import {
    ArrowRight
} from "lucide-react";


const JourneyProgressCard = () => {

    /* =====================================================
       EMAIL
    ===================================================== */

    const email =
        localStorage.getItem(
            "user_email"
        );


    /* =====================================================
       JOURNEY STATE
    ===================================================== */

    const [
        journey,
        setJourney
    ] = useState(null);


    /* =====================================================
       ASSESSMENTS STATE
    ===================================================== */

    const [
        assessments,
        setAssessments
    ] = useState(0);


    /* =====================================================
       FETCH DATA
    ===================================================== */

    useEffect(() => {

        if (!email) {
            return;
        }

        fetchJourney();

        fetchDashboard();

    }, [email]);


    /* =====================================================
       FETCH JOURNEY
    ===================================================== */

    const fetchJourney = async () => {

        try {

            const response =
                await axios.get(

                    `/api/ignite/journey/${encodeURIComponent(
                        email
                    )}`

                );


            console.log(
                "JOURNEY API RESPONSE:",
                response.data
            );


            if (
                response.data?.success
            ) {

                setJourney(
                    response.data
                );

            }

        }

        catch (error) {

            console.error(
                "Journey API Error:",
                error
            );

        }

    };


    /* =====================================================
       FETCH DASHBOARD
    ===================================================== */

    const fetchDashboard = async () => {

        try {

            const response =
                await axios.get(

                    `/api/dashboard/${encodeURIComponent(
                        email
                    )}`

                );


            console.log(
                "DASHBOARD API RESPONSE:",
                response.data
            );


            setAssessments(

                Number(
                    response.data
                        ?.totalTestsCompleted
                ) || 0

            );

        }

        catch (error) {

            console.error(
                "Dashboard API Error:",
                error
            );

        }

    };


    /* =====================================================
       CURRENT LEVEL

       IMPORTANT:

       Backend response:

       levelObjectives: {
           currentLevel: 3,
           completed: ...,
           total: ...,
           progress: ...
       }

       So current level must be taken from:

       journey.levelObjectives.currentLevel
    ===================================================== */

    const level =
        Number(

            journey
                ?.levelObjectives
                ?.currentLevel

        ) || 1;


    /* =====================================================
       PROGRESS
    ===================================================== */

    const progress =
        Number(

            journey
                ?.levelObjectives
                ?.progress

        ) || 0;


    /* =====================================================
       COMPLETED
    ===================================================== */

    const completed =
        Number(

            journey
                ?.levelObjectives
                ?.completed

        ) || 0;


    /* =====================================================
       TOTAL
    ===================================================== */

    const total =
        Number(

            journey
                ?.levelObjectives
                ?.total

        ) || 0;


    /* =====================================================
       LEVEL NAMES
    ===================================================== */

    const levelNames = {

        1: "ROOKIE",

        2: "CONTENDER",

        3: "PERFORMER",

        4: "ELITE"

    };


    /* =====================================================
       NEXT LEVEL NAMES
    ===================================================== */

    const nextLevelNames = {

        1: "CONTENDER",

        2: "PERFORMER",

        3: "ELITE",

        4: "MAX LEVEL"

    };


    /* =====================================================
       CURRENT LEVEL NAME
    ===================================================== */

    const currentLevelName =
        levelNames[level] ||
        "ROOKIE";


    /* =====================================================
       NEXT LEVEL NAME
    ===================================================== */

    const nextLevelName =
        nextLevelNames[level] ||
        "MAX LEVEL";


    /* =====================================================
       RENDER
    ===================================================== */

    return (

        <div
            className="journey-card"
        >


            {/* =================================================
               HEADER
            ================================================= */}

            <div
                className="journey-top"
            >

                <div>

                    <h3>
                        Journey Progress
                    </h3>

                    <p>
                        Continue your Ignite journey.
                    </p>

                </div>


                {/* =============================================
                   PROGRESS CIRCLE
                ============================================= */}

                <div

                    className="progress-circle"

                    style={{

                        background:
                            `conic-gradient(
                                #2563EB ${
                                    progress * 3.6
                                }deg,
                                #E5E7EB 0deg
                            )`

                    }}

                >

                    <div
                        className="progress-inner"
                    >

                        <span>

                            {
                                Math.round(
                                    progress
                                )
                            }%

                        </span>

                    </div>

                </div>

            </div>


            {/* =================================================
               STATS
            ================================================= */}

            <div
                className="journey-stats"
            >


                {/* =============================================
                   CURRENT LEVEL
                ============================================= */}

                <div>

                    <span>
                        Current Level
                    </span>

                    <h2>

                        {
                            currentLevelName
                        }

                    </h2>

                </div>


                {/* =============================================
                   ASSESSMENTS
                ============================================= */}

                <div>

                    <span>
                        Assessments
                    </span>

                    <h2>

                        {
                            assessments
                        }

                    </h2>

                </div>

            </div>


            {/* =================================================
               FOOTER
            ================================================= */}

            <div
                className="journey-footer"
            >

                <div>

                    <span>
                        Next Level
                    </span>

                    <strong>

                        {
                            nextLevelName
                        }

                    </strong>


                    <p
                        style={{

                            marginTop: 8,

                            color:
                                "#64748B",

                            fontSize:
                                14

                        }}
                    >

                        {
                            completed
                        }

                        {" / "}

                        {
                            total
                        }

                        {" Objectives Completed"}

                    </p>

                </div>


                {/* =============================================
                   VIEW JOURNEY
                ============================================= */}

                <button>

                    View Journey

                    <ArrowRight
                        size={18}
                    />

                </button>

            </div>


        </div>

    );

};


export default JourneyProgressCard;